import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AngularGridInstance, Formatters, GridOption, FieldType} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SocketService} from '../socket.service';

@Component({
    selector: 'app-view-ticket-cit-apps',
    templateUrl: './view-ticket-cit-apps.component.html',
    styleUrls: ['./view-ticket-cit-apps.component.css']
})
export class ViewTicketCitAppsComponent implements OnInit, OnDestroy {
    ticketTypeLoaded = false;
    displayed = true;
    folderDisplayed = true;
    cat = [];
    step: string;
    assignGroupLength: number;
    typeChecked: string;
    columnDefinitions = [];
    gridOptions: GridOption;
    dataset: any[];
    angularGrid: AngularGridInstance;
    totalData: number;
    selectedTitles = [];
    selectedTitles2 = [];
    gridObj: any;
    show: boolean;
    selected: number;
    ticketId: string;
    // tType: string;
    defaultStatus = false;
    defaultUser = false;
    defaultNextUser = false;
    name: string;
    desc: string;
    brief: string;
    rDate: string;
    dDate: string;
    comment: string;
    priority: string;
    ticketCreated = false;
    percent: number;
    canForward = false;

    @ViewChild('content') private content;
    ticketTypes: any;
    solution: string;
    types = [];
    rca: string;
    notifier: NotifierService;
    respObject: any;
    clientId: number;
    assignedUser: any;
    assignedGroup: any;
    currentUser: string;
    currentGroup: string;
    groups = [];
    supportGroupSelected: number;
    statusSelected: number;
    users = [];
    status = [];
    userSelected: number;
    assignee_copy: string;
    private groupDetails: any;
    private tId: any;
    lastCatId: number;
    lastParentId: number;
    totalItems: number;
    private statusIndex: any;
    statusName: string;
    private createbyid: any;
    private wfcresultId: any;
    respTime: string;
    comments = [];
    assignedToMe = false;
    closedticket = false;
    endIndicator = true;
    slaViolated = false;
    logs = [];
    private gid: number;
    private gid_copy: number;
    private aid: any;
    count: number;
    solutions = [];
    private modalReference: NgbModalRef;
    folderClicked: any;
    createdByMe = false;
    attachments = [];
    attachment = [];
    replyAttachment = [];
    uploadButtonName = 'Upload File';
    fileUploadUrl: string;
    formData: any;
    menus = [];
    ticketTab = true;
    commentsTab = true;
    solTab = true;
    attachTab = true;
    logTab = true;
    tabs: any;
    private slaTime: any;
    hasFollowupUser: boolean;
    followupUser: string;
    private SLA_INTERVAL_TIME = 60 * 1000;
    slaString: any;
    outerColor: any;
    innerColor: any;
    outerColorResp: any;
    innerColorResp: any;

    masterNameObj = [];
    page = 1;
    MAX_SIZE = 4;
    collectionSize: number;
    LIMIT = 7;
    start = 0;
    isDisabled = true;
    dynamicFields: any;
    private masterName: string;
    masterNameSelected: number;
    data = [];
    viewIncidentData = [];
    columnData = [];
    data2 = [];
    masterDataNameSelected: number;
    actions = [];
    statusSeq: number;
    escalatedTicket = false;
    seq: number;
    isAsset: boolean;
    addIncidentData = [];
    selectedTitles4 = [];
    inciId: number;
    isApprovedTicket: boolean;
    isApproved: string;
    worker: any;
    searchTid: string;
    ticketCount: number;
    private addedTicket = [];
    isAddIncident: boolean;
    isViewIncident: boolean;
    userGroupId: number;
    canAddSolution: boolean;
    canAddComment: boolean;
    typeSeq: any;
    subRadioDisplay: boolean;
    subtypes = [];
    subTypeId: any;
    @ViewChild('statusChange') private statusChange;
    PROBLEM_SOLUTION_PROVIDED = 103;
    private INCIDENT_TYPE_SEQ = 1;
    folderLoaded = false;
    solLoaded: boolean;
    comLoaded: boolean;
    resoTime: string;
    hideAttachment: boolean;
    replyHideAttachment: boolean;
    attachMsg: string;
    userGroups = [];
    @ViewChild('groupSelect') private groupSelect;
    private dialogRef: MatDialogRef<any, any>;
    userGroupSelected = 0;
    isRInfo: boolean;
    loginName: string;
    email: string;
    mobile: string;
    username: string;
    groupName: string;
    searchType: string;
    searchTypeStatus: string;

    public grpLevel: number;
    isLowestLevel: boolean;
    solProvided = false;

    claimNo: string;

    private ticketTypeSubscription: Subscription;
    private priorityId: number;
    escLevel: string;
    catFilterVal = 0;
    userFilterVal = 0;

    private userAuth: Subscription;

    ticketIdSearchLoaded: boolean;
    allStatus = [];
    filterSearchLoaded: boolean;
    categoryLoaded = false;
    inciCategories = [];
    searchCat = [];
    startDate: any;
    endDate: any;
    priorityType: number;
    isViewTicket: boolean;
    dataLoaded: boolean;
    nextOffset: number;
    pageSize: number;
    service: any;
    pageSizeObj: any[];
    pageNo: number;
    totalPage: number;
    pageSizeSelected: number;
    paginationObj: any;
    offset: number;
    previousOffset: number;
    page_no: number;
    private masterCloseSubscribe: Subscription;
    workspaces = [];
    workType: string;
    private dashboardSubscribe: Subscription;
    displayCit: boolean;
    displayCr: boolean;
    displayPr: boolean;
    load: boolean;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, private socketService: SocketService,
                private dialog: MatDialog, notifier: NotifierService, private actRoute: ActivatedRoute) {
        this.notifier = notifier;
        this.masterCloseSubscribe = this.messageService.masterCloseModalSubject.subscribe((data) => {
            this.viewTicketList(data, {'offset': 0, 'paginationType': ''});
        });
        // this.attachmentSubscribe = this.socketService.attachmentSubject.subscribe((data) => {
        //     if (this.userGroupId === data.groupId) {
        //         // console.log('-->: ' + JSON.stringify(data));
        //         if (this.tId === data.ticketId) {
        //             this.displayNewAttachment = true;
        //             delete data.ticketId;
        //             delete data.groupId;
        //         }
        //     }
        // });
        // this.solSubscribe = this.socketService.solPrvdSubject.subscribe((data) => {
        //     if (this.userGroupId === data.groupId) {
        //         // console.log('-->: ' + JSON.stringify(data));
        //         if (this.tId === data.ticketId) {
        //             this.displayNewSolutions = true;
        //             this.lastSol = data.solutions;
        //             delete data.ticketId;
        //             delete data.groupId;
        //             this.solutions.unshift(data);
        //         }
        //     }
        // });
        this.dashboardSubscribe = this.socketService.dashboardSubject.subscribe((data) => {
            if (this.userGroupId === data.groupId) {
                console.log('-->: ' + JSON.stringify(data));
                const menuId = data.menuId;
                const displayelem = document.getElementById('menu_' + menuId);
                if (displayelem !== undefined && displayelem !== null) {
                    // displayelem.classList.remove('none');
                    displayelem.classList.add('unseen');
                }
            }
        });
    }


    angularGridReady(angularGrid: AngularGridInstance) {
        // console.log('grid initiate');
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    onPager(pageNumber: number): void {
        // console.log('Pager event Is: ', pageNumber);
        this.start = (pageNumber * this.LIMIT) - this.LIMIT;
        this.folderClick(this.folderClicked);
        // console.log('start:' + this.start);
    }

    ngOnInit() {
        this.displayCit = false;
        this.displayCr = false;
        this.displayPr = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.page_no = 0;
        this.pageSizeObj = this.messageService.searchPagination;
        this.pageSizeSelected = this.messageService.searchPageSelected;
        this.pageSize = this.messageService.searchPageSize;
        this.pageNo = 0;
        this.paginationObj = {'offset': this.nextOffset, 'paginationType': ''};
        this.totalPage = 0;
        // -----------------------------------------
        this.dataLoaded = true;
        this.isViewTicket = true;
        this.dynamicFields = [];
        this.rDate = '';
        this.dDate = '';
        this.subRadioDisplay = false;
        this.isRInfo = false;
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        // this.percent = 0;
        this.searchType = 'id';
        this.searchTypeStatus = 'opn';
        this.columnDefinitions = [];

        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.userGroups = this.messageService.groupId;
            if (this.userGroups !== undefined) {
                if (this.messageService.getSupportGroup() === null) {
                    this.userGroupId = this.userGroups[0].groupId;
                    this.groupName = this.userGroups[0].grpName;
                    this.grpLevel = this.userGroups[0].level;

                } else {
                    const group = this.messageService.getSupportGroup();
                    // // console.log(group, typeof group);
                    this.userGroupId = group.groupId;
                    this.groupName = group.grpName;
                    this.grpLevel = group.level;
                }
                this.userGroupSelected = this.userGroupId;
            }
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.clientId = auth[0].clientId;
                this.userGroups = auth[0].groupId;
                if (this.userGroups !== undefined) {
                    if (this.messageService.getSupportGroup() === null) {
                        this.userGroupId = this.userGroups[0].groupId;
                        this.groupName = this.userGroups[0].grpName;
                        this.grpLevel = this.userGroups[0].level;

                    } else {
                        const group = this.messageService.getSupportGroup();
                        // // console.log(group, typeof group);
                        this.userGroupId = group.groupId;
                        this.groupName = group.grpName;
                        this.grpLevel = group.level;
                    }
                    this.userGroupSelected = this.userGroupId;
                }
                this.onPageLoad();
            });
        }
        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            // enableCheckboxSelector: true,
            enableRowSelection: true,

        };
        this.dataset = [];
    }

    onPageLoad() {
        if (this.grpLevel === 0) {
            this.workspaces = [{id: '1', name: 'My Workspace'}];
        } else if (this.grpLevel > 0 && this.grpLevel < 3) {

            this.workspaces = [{id: '1', name: 'My Workspace'}, {id: '2', name: 'Team Workspace'}];
        } else {
            this.workspaces = [{id: '2', name: 'Team Workspace'}];
        }
        this.ticketTypeSubscription = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
            this.respObject = res1;

            // console.log('-----------inside  View Ticket');
            this.ticketTypeLoaded = true;
            this.load = false;
            if (this.respObject.success) {
                const storage = JSON.parse(sessionStorage.getItem('dd'));
                this.types = this.respObject.details;
                this.types[0].checked = false;
                if (storage === null) {
                    for (let i = 0; i < this.types.length; i++) {
                        if (this.types[i].view_sequence === 2) {
                            this.typeChecked = this.types[i].id;
                            this.seq = this.types[i].seq;
                            this.types[i].checked = true;
                            this.setDisplayModal();
                        }
                    }
                } else {
                    const type = storage.type;
                    // this.folderClicked = this.storage.id;
                    this.catFilterVal = storage.cat;
                    this.userFilterVal = storage.user;
                    // this.types[0].checked = false;
                    for (let i = 0; i < this.types.length; i++) {
                        // console.log(this.types[i].id, type);
                        if (this.types[i].id === type) {
                            this.typeChecked = this.types[i].id;
                            this.seq = this.types[i].seq;
                            this.load = true;
                            this.types[i].checked = true;
                            this.setDisplayModal();
                            break;
                        }
                    }
                    if (!this.load) {
                        // console.log("load"+ this.load);
                        for (let i = 0; i < this.types.length; i++) {
                            if (this.types[i].view_sequence === 2) {
                                this.typeChecked = this.types[i].id;
                                this.types[i].checked = true;
                                this.setDisplayModal();
                                // this.typeSeq = this.radioButton[i].seq;
                                break;
                            }
                        }
                    }
                    // console.log('---------> type: ' + this.typeChecked);
                }
                // this.messageService.setTicketType(this.typeChecked);
                // // console.log(typeof this.seq, this.seq);

                for (let i = 0; i < this.types.length; i++) {
                    if (this.types[i].seq === this.INCIDENT_TYPE_SEQ) {
                        this.inciId = this.types[i].id;
                        break;
                    }
                }
                this.getColumnDefintion();
                this.getDynamicMenuTicketTypeWise();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getDynamicMenuTicketTypeWise() {
        const wstorage = this.messageService.getWorkspace();

        if (wstorage !== null) {
            // this.workType = wstorage;
            let matched = false;
            for (let i = 0; i < this.workspaces.length; i++) {
                if (this.workspaces[i].id === wstorage) {
                    this.workType = wstorage;
                    matched = true;
                    break;
                }
            }
            if (!matched) {
                this.workType = this.workspaces[0].id;
            }
        } else {
            this.workType = this.workspaces[0].id;
        }
        this.messageService.setWorkspace(this.workType);
        this._rest.getDynamicMenuTicketTypeWise(this.clientId, this.typeChecked,
            this.messageService.getUserId(), 1, this.userGroupId, this.workType).subscribe((res2) => {
            this.respObject = res2;
            // console.log("........."+JSON.stringify(this.respObject));
            this.folderLoaded = true;
            if (this.respObject.success) {
                this.menus = this.respObject.details;
                const storage = JSON.parse(sessionStorage.getItem('dd'));
                if (storage !== null) {
                    const type = storage.type;
                    if (type === this.typeChecked) {
                        // console.log(this.storage.id, typeof this.storage.id);
                        if (storage.id) {
                            sessionStorage.setItem('dd', JSON.stringify({
                                type: this.typeChecked,
                                seq: storage.seq,
                                user: storage.user,
                                cat: storage.cat
                            }));
                            this.clickedFilter(storage.id);
                        }
                    } else {
                        if (this.menus.length > 0) {
                            sessionStorage.setItem('dd', JSON.stringify({
                                type: this.typeChecked,
                                seq: this.seq,
                                user: storage.user,
                                cat: storage.cat
                            }));
                            this.clickedFilter(this.menus[0].fid);
                        } else {
                            sessionStorage.setItem('dd', JSON.stringify({
                                type: this.typeChecked,
                                seq: this.seq,
                                user: storage.user,
                                cat: storage.cat
                            }));
                        }
                    }
                } else {
                    if (this.menus.length > 0) {
                        sessionStorage.setItem('dd', JSON.stringify({
                            type: this.typeChecked,
                            user: 0,
                            cat: 0,
                            seq: this.seq
                        }));
                        this.clickedFilter(this.menus[0].fid);
                    } else {
                        sessionStorage.setItem('dd', JSON.stringify({
                            type: this.typeChecked,
                            seq: this.seq,
                            user: 0,
                            cat: 0
                        }));
                    }
                }
                this._rest.checkOfflineDashNotification(this.clientId, this.userGroupId,
                    this.messageService.getUserId(), this.typeChecked, 1).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        const result = this.respObject.details;
                        // this.menus = this.respObject.details;
                        for (let i = 0; i < result.length; i++) {
                            const menuId = result[i].noti_type;
                            const displayelem = document.getElementById('menu_' + menuId);
                            if (displayelem !== undefined && displayelem !== null) {
                                // displayelem.classList.remove('none');
                                displayelem.classList.add('unseen');
                            }
                        }
                    }
                });
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    toggleViews() {
        this.displayed = !this.displayed;
    }

    toggleFolderViews() {
        this.folderDisplayed = !this.folderDisplayed;
    }

    changeRouting() {
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
        // this.route.navigate(['ticket/dashboard']);
    }

    setDisplayModal() {
        if (this.seq === 5) {
            this.displayCr = true;
            this.displayPr = false;
            this.displayCit = false;
        } else if (this.seq === 6) {
            this.displayPr = true;
            this.displayCr = false;
            this.displayCit = false;
        } else {
            this.displayCit = true;
            this.displayPr = false;
            this.displayCr = false;
        }
    }

    onButtonChange(value) {
        // // console.log(value.value);
        this.typeChecked = value.value.id;
        this.seq = value.value.seq;
        this.getColumnDefintion();
        this.getDynamicMenuTicketTypeWise();
        this.dataset = [];
        this.totalItems = 0;
        this.setDisplayModal();
    }

    getColumnDefintion() {
        this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.typeChecked).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                const data = this.respObject.details;
                // // console.log(JSON.stringify(data));
                this.columnDefinitions = [
                    // {id: 'id', name: 'Id', field: 'id', minWidth: 80, sortable: true, filterable: true},
                    {id: 'ticket_id', name: 'Ticket Id', field: 'ticket_id', minWidth: 200, sortable: true, filterable: true},
                    {id: 'ticket_name', name: 'Ticket Title', field: 'tName', minWidth: 200, sortable: true, filterable: true},
                    {
                        id: 'createdBy', name: 'Created By', field: 'createdBy', minWidth: 200, sortable: true, filterable: true
                    },
                    {
                        id: 'createdSince',
                        name: 'Created Since',
                        field: 'createdSince',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                        // type: FieldType.dateIso
                    },
                    {
                        id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 150, filterable: true
                    },
                    {
                        id: 'reqInfo', name: 'RequesterInfo', field: 'reqInfo', minWidth: 100, sortable: true, filterable: true
                    },
                    {
                        id: 'assignee', name: 'Assignee', field: 'assignee', minWidth: 150, sortable: true, filterable: true
                    },
                    {
                        id: 'LEVELSHORTDESC', name: 'Group', field: 'LEVELSHORTDESC', minWidth: 100, sortable: true, filterable: true
                    },
                    {
                        id: 'dDate',
                        name: 'Due Date',
                        field: 'dDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                        // formatter: Formatters.dateTimeIso,
                        // type: FieldType.dateIso
                    },
                    {
                        id: 'updateDate',
                        name: 'Last Update Date',
                        field: 'updateDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                        // type: FieldType.dateIso
                    },
                    {
                        id: 'updateBy', name: 'Last Updated By', field: 'updateBy', minWidth: 150, sortable: true, filterable: true
                    },
                    {
                        id: 'closureDate', name: 'Closure Date', field: 'ticketCloseDate', minWidth: 150, sortable: true, filterable: true
                    },
                    {
                        id: 'escLevel',
                        name: 'Escalation Level',
                        field: 'escalated_to_grp_nm',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                    }
                ];
                if (this.grpLevel !== 0) {
                    this.columnDefinitions.push({
                        id: 'priority', name: 'Priority', field: 'priority', minWidth: 100, sortable: true, filterable: true
                    });
                }
                for (let i = 0; i < data.length; i++) {
                    this.columnDefinitions.push({
                        id: data[i].field, name: data[i].name, field: data[i].field, minWidth: 100, sortable: true, filterable: true
                    });
                }
                const classes = document.getElementsByClassName('search-filter');
                for (let i = 0; i < classes.length; i++) {
                    classes[i].setAttribute('placeholder', '');
                }
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    onCellClicked(e, args) {
        const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
        const data = selectedRow.dataContext;
        this.messageService.setModalData(data);
        this.setDisplayModal();
    }

    terminateWorker() {
        if (this.worker) {
            this.worker.terminate();
        }
    }


    // checkCanAddSolution() {
    //     let matched = false;
    //     for (let i = 0; i < this.wGroups.length; i++) {
    //         if (this.wGroups[i].id === this.userGroupId) {
    //             matched = true;
    //             this.canAddSolution = true;
    //             break;
    //         }
    //     }
    //     if (!matched) {
    //         this.canAddSolution = false;
    //     }
    // }

    folderClick(value) {
        // console.log('clicked: ' + value, this.typeChecked, this.userGroupId);
        this.folderClicked = value;
        if (!this.typeChecked) {
            alert('Select Ticket Type First');
        } else {
            console.log('clicked', value);
            this.viewTicketList(value, {'offset': 0, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    viewTicketList(value, paginationObj) {
        // console.log(paginationObj, value);
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        if (offset === 0) {
            this.page_no = 0;
        }
        const params = {
            user_id: this.messageService.getUserId(),
            ticketTypeId: this.typeChecked,
            supportgrp_id: this.userGroupId,
            seq:this.seq,
            clientId: this.clientId,
            menuId: value,
            catFilterVal: this.catFilterVal,
            userFilterVal: this.userFilterVal,
            page_size: this.pageSize,
            nextOffset: offset,
            paginationType: paginationType,
            specialFilterVal: '0',
            isLNTSSC :  '0',
        };
        this.dataLoaded = false;
        this._rest.getDynamicMenuTicketDtls_new(params).subscribe((res1) => {
            this.displayTicket(res1, offset, paginationType);
        }, (err) => {
            // this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
        const displayelem = document.getElementById('menu_' + value);
        if (displayelem !== undefined && displayelem !== null) {
            // displayelem.classList.remove('none');
            displayelem.classList.remove('unseen');
        }
        const data = {
            groupId: this.userGroupId,
            user_id: this.messageService.getUserId(),
            type: value,
            clientId: this.clientId
        };
        this._rest.updateOfflineNotificationData(data).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
            }
        });
    }

    onCellChanged(e, args) {
        // console.log(args.item);
    }

    handleSelectedRowsChanged(e, args) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles = args.rows.map(idx => {
                const item = this.gridObj.getDataItem(idx);
                return item || '';
            });
            if (this.selectedTitles.length > 0) {
                this.show = true;
                this.selected = this.selectedTitles.length;
            } else {
                this.show = false;
            }
            // console.log(JSON.stringify(this.selectedTitles));
        }
    }

    onSelectGroup() {
        // // console.log(typeof this.userGroupSelected);
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            if (this.grpLevel === 0) {
                this.workType = '1';
                this.messageService.setWorkspace(this.workType);
            }
            this.messageService.saveSupportGroup({groupId: this.userGroupId, grpName: this.groupName, level: this.grpLevel});
            this.dataset = [];
            this.totalItems = 0;
            this.onPageLoad();
        }
    }

    displayTicket(res1, offset, paginationType) {
        this.respObject = res1;
        this.dataLoaded = true;
        if (this.respObject.success) {

            // // console.log(JSON.stringify(this.respObject));
            // this.types = this.respObject.details;
            this.dataset = [];

            const uniqueData = this.respObject.details.dataObj.filter(
                (item, index, self) =>
                  index === self.findIndex((obj) => obj.id === item.id)
              );


            // console.log(this.dataset);
            for (let i = 0; i < uniqueData.length; i++) {
                // if (this.respObject.details[i].id === 51) {
                //     // console.log(new Date(this.respObject.details[i].createdSince));
                // }
                uniqueData[i].createdSince =
                    this.messageService.datePipeFunc(uniqueData[i].createdSince);
                uniqueData[i].dDate =
                    this.messageService.datePipeFunc(uniqueData[i].dDate);
                uniqueData[i].updateDate =
                    this.messageService.datePipeFunc(uniqueData[i].updateDate);
                if (uniqueData[i].ticketCloseDate === undefined || uniqueData[i].ticketCloseDate === '' ||
                    uniqueData[i].ticketCloseDate === null) {
                    uniqueData[i].ticketCloseDate = '';
                } else {
                    uniqueData[i].ticketCloseDate =
                        this.messageService.datePipeFunc(uniqueData[i].ticketCloseDate);
                }
                uniqueData[i].requestedDate =
                    this.messageService.datePipeFunc(uniqueData[i].requestedDate);
            }
            // ========================================================================
            if (offset === 0) {
                this.totalData = this.respObject.details.totalData[0].count;
                this.totalPage = this.respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            // console.log(this.dataset);
            console.log('respose Details====' + JSON.stringify(this.respObject.details));
            if (uniqueData.length > 0) {
                this.dataset = uniqueData;
                this.nextOffset = this.respObject.details.nextOffset;
                this.offset = this.respObject.details.nextOffset;
                this.previousOffset = this.respObject.details.previousOffset;
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
                if (this.page_no === 1) {
                    this.previousOffset = 0;
                }
            } else if (uniqueData.length === 0 && paginationType === 'next') {
                // console.log('next ====' + this.page_no);
                this.nextOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
            // console.log(this.dataset);
            // console.log('n==' + this.nextOffset + '==p===' + this.previousOffset + '===totalData==' + this.totalData + '===pageSize===' +
            //     this.pageSize + '===pageno===' + this.page_no);
            // ========================================================================
            // this.gridOptions = Object.assign({}, this.gridOptions);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }

    onSubButtonChange(value) {
        this.subTypeId = value.value.id;
        // // console.log(this.subTypeId);
    }

    clickedFilter(fid: any) {
        // console.log(this.step);
        this.step = fid;
        const storage = JSON.parse(sessionStorage.getItem('dd'));
        storage.id = fid;
        sessionStorage.setItem('dd', JSON.stringify(storage));
        this.folderClick(fid);
    }

    getNextData() {
        this.viewTicketList(this.folderClicked, {'offset': this.nextOffset, 'paginationType': 'next'});
    }

    getPreviousData() {
        this.viewTicketList(this.folderClicked, {'offset': this.previousOffset, 'paginationType': 'prev'});
    }

    onPageSizeChange(value: any) {
        this.pageSize = this.pageSizeObj[value].value;
        this.viewTicketList(this.folderClicked, {'offset': 0, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.ticketTypeSubscription) {
            this.ticketTypeSubscription.unsubscribe();
        }
        if (this.masterCloseSubscribe) {
            this.masterCloseSubscribe.unsubscribe();
        }
        if (this.dashboardSubscribe) {
            this.dashboardSubscribe.unsubscribe();
        }
    }

    getTableData(value) {
        this.dataset = value.dataset;
    }

    onWorkTypeChange() {
        // this.wor
        this.messageService.setWorkspace(this.workType);
        const data = JSON.parse(sessionStorage.getItem('dd'));
        delete data.id;
        this.dataset = [];
        // console.log(JSON.stringify(data));
        sessionStorage.setItem('dd', JSON.stringify(data));
        this.step = '0';
        this.totalData = 0;
        this.getDynamicMenuTicketTypeWise();
    }
}
